// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XOkFJ","left":"styles_left__3UV7Z","select":"styles_select__f-kDE"};